/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  CmsConfig, ConfigModule, I18nConfig, I18nModule, provideConfig, provideDefaultConfig,
  UrlModule
} from '@spartacus/core';
import {
  FormErrorsModule,
  GlobalMessageComponentModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SpinnerModule
} from '@spartacus/storefront';
import { ClaimsComponent } from './claims.component';
import { ClaimsService } from './claims.service';


@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    GlobalMessageComponentModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ClaimCreationComponent: {
          component: ClaimsComponent,
        },

      },

    } as CmsConfig),
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ClaimCreationComponent: ClaimsComponent
      }
    }),ClaimsService
  ],
  declarations: [ClaimsComponent],
})
export class ClaimsModule { }

